(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("next-core-model"), require("presentation-request"), require("presentation-storage"));
	else if(typeof define === 'function' && define.amd)
		define("presentation-models", ["next-core-model", "presentation-request", "presentation-storage"], factory);
	else if(typeof exports === 'object')
		exports["presentation-models"] = factory(require("next-core-model"), require("presentation-request"), require("presentation-storage"));
	else
		root["presentation-models"] = factory(root["next-core-model"], root["presentation-request"], root["presentation-storage"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 